import {format, setHours, setMinutes} from "date-fns";
import React, {Component} from "react";
import {Modal} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {connect} from "react-redux";
import {toast} from "react-toastify";
import {
    BookingAddParticular,
    BookingChangeHandler,
    BookingSetToDefault,
    removeBookingParticular,
} from "../../../redux/actions/Booking.Action";
import {CustomerCustomersList} from "../../../redux/actions/Modules.Action";
import ApiConnect from "../../../Utils/ApiConnect";
import BarcodeScanner from '../../Components/BarcodeScanner/index';
import NewCustomerModal from "../Customer/Customers/NewCustomerModal";
import ProductAutoComplete from "../SalesPurchase/Components/ProductAutoComplete";

class NewBooking extends Component {
  state = {
    product: "",
    id: "",
    qty: 0,
    free: 0,
    rate: 0,
    tax: 0,
    taxAmt: 0,
    netAmt: 0,
    remainQty: 0,
    stock: 0,
    reset: false,
    formError: false,
    landmark: "",
    ProductList: false,
    previewImage: [],
    docs: [],
    btnDisable: false,
    selAccount: [],
    showModal: false,
    sameAsOrder: true,
    Ddate: "",
  };
  componentDidMount() {
    this.fetchCustomerData();
    this.fetchProductData();
  }
  handleDateChange = (e) => {
    this.setState({ Ddate: e });
  };
  fetchCustomerData() {
    ApiConnect.get(`/Members/Information/CustomerList`)
      .then((response) => {
        this.props.CustomerCustomersList(response.data.data);
      })
      .catch((error) => console.log(error));
  }
  fetchProductData = async () => {
    try {
      const resp = await ApiConnect.get("/Module/Inventory/Product/Details");
      this.setState({ ProductList: resp.data });
    } catch (err) {
      console.error(err);
    }
  };
  imageHandleChange(e) {
    if (e.target.files) {
      const fileArray = Array.from(e.target.files).map((file) =>
        URL.createObjectURL(file)
      );
      this.setState({ docs: e.target.files, previewImage: fileArray });
    }
  }
  setSelectedAccount = (e) => {
    this.setState({ selAccount: e });
    this.props.BookingChangeHandler(e);
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.BookingAddParticular(this.state);
    this.setState({
      product: "",
      id: "",
      qty: 0,
      free: 0,
      rate: 0,
      tax: 0,
      taxAmt: 0,
      netAmt: 0,
      remainQty: 0,
      reset: true,
      stock: 0,
      landmark: "",
    });
  };
  handelBarcodeScanner = (e) => {
    let stateData = this.state;
    const NetAmt = 1 * e.price;
    const TaxAmt = parseFloat((this.state.tax * NetAmt) / 100);
    stateData["product"] = e.name;
    stateData["id"] = e.id
    stateData["qty"] = 1
    stateData["rate"] = e.price
    stateData["tax"] = this.state.tax
    stateData["taxAmt"] = TaxAmt
    stateData["netAmt"] = parseFloat(NetAmt + TaxAmt);
    stateData["note"] = "";
    this.props.BookingAddParticular(stateData);
  }

  ProductChange = (e) => {
    this.setState({
      product: e.name,
      id: e.id,
      remainQty: parseFloat(e.stock),
      stock: parseFloat(e.stock),
      rate: parseFloat(e.price),
      tax: parseFloat(e.vat),
    });
  };
  CalculateNetAmt = (e) => {
    let TotalQty = 0;
    let NetAmt = 0;
    let TaxAmt = 0;
    let tempState = { ...this.state };
    const val = parseFloat(e.target.value || 0);
    tempState[e.target.name] = val || 0;
    if (e.target.name === "qty") {
      TotalQty = parseFloat(this.state.free + val);
      NetAmt = val * this.state.rate;
    }
    if (e.target.name === "free") {
      TotalQty = this.state.qty + val;
      NetAmt = this.state.qty * this.state.rate;
    }
    TaxAmt = parseFloat((this.state.tax * NetAmt) / 100);
    tempState["remainQty"] = parseFloat(this.state.stock - TotalQty);
    tempState["netAmt"] = parseFloat(NetAmt + TaxAmt);
    tempState["taxAmt"] = TaxAmt;
    this.setState(tempState);
  };
  ChangeProductStatus = () => {
    this.setState({ reset: false });
  };

  handleSalesSubmit = () => {
    this.setState({ btnDisable: true });
    const BookingData = this.props.BookingData;
    const particular = BookingData.particulars;
    var Fdata = new FormData();
    Fdata.append("Ddate", format(this.state.Ddate, "yyyy-MM-dd h:mm aa"));
    Fdata.append("customer", BookingData.customer.id);
    Fdata.append("Dtype", BookingData.type);
    Fdata.append(
      "Daddress",
      BookingData.sameAsOrder
        ? BookingData.customer.address.address || BookingData.Daddress
        : BookingData.Daddress
    );
    Fdata.append(
      "Dcontact",
      BookingData.Dcontact
        ? BookingData.Dcontact
        : BookingData.sameAsOrder
          ? BookingData.customer.id
          : BookingData.Dcontact
    );
    Fdata.append(
      "landmark",
      BookingData.sameAsOrder
        ? BookingData.customer.address.landmark || BookingData.landmark
        : BookingData.landmark
    );
    Fdata.append("payment", BookingData.payment);
    particular.forEach((x) => {
      Fdata.append("product[]", x.name);
      Fdata.append("id[]", x.id);
      Fdata.append("qty[]", x.qty);
      Fdata.append("free[]", x.free);
      Fdata.append("rate[]", x.rate);
      Fdata.append("note[]", x.note);
    });
    Fdata.append("total", BookingData.grandTotal);
    Fdata.append("netamount", BookingData.netAmount);
    Fdata.append("advance", BookingData.advance);
    Fdata.append("delivery", BookingData.delivery);
    Fdata.append("narration", BookingData.remark);
    for (let i = 0; i < this.state.docs.length; i++) {
      Fdata.append("images_files[]", this.state.docs[i]);
    }
    ApiConnect({
      method: "post",
      url: "/Module/Booking/Main/NewBooking",
      data: Fdata,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({
            product: "",
            id: "",
            qty: 0,
            free: 0,
            rate: 0,
            tax: 0,
            taxAmt: 0,
            netAmt: 0,
            remainQty: 0,
            stock: 0,
            reset: false,
            formError: false,
            accountHead: false,
            ProductList: false,
            previewImage: [],
            docs: [],
            btnDisable: false,
          });
          this.props.BookingSetToDefault();
        } else if (response.data.status) {
          this.setState({ formError: response.data.message });
        }
      })
      .catch((error) => console.log(error));
  };
  render() {
    const BookingData = this.props.BookingData;
    const AccountData = this.props.AccountData;
    const CustomerList = this.props.CustomerList;
    var today = new Date();
    return (
      <>
        <div className="card">
          <div className="card-title">
            <div className="d-flex">
              <h5 className="col">New Booking</h5>
              <div className="col-1">
                <button
                  className="btn btn-primary btn-square btn-round"
                  onClick={() => {
                    this.setState({ showModal: true });
                  }}
                >
                  <span className="material-icons-outlined">add</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="card ">
              <div className="card-body">
                <strong>Customer Info</strong>
                {CustomerList.length !== 0 ? (
                  <div className="form-group">
                    <ProductAutoComplete
                      action={this.setSelectedAccount}
                      name="account"
                      value={AccountData.name}
                      placeHolder="Customer Name / Number"
                      styleName="form-control input-sm d-block"
                      items={CustomerList}
                    />
                  </div>
                ) : (
                  ""
                )}
                <address>
                  <br />
                  <b>Address: </b>
                  {AccountData.address ? AccountData.address.address : ""}
                  <br />
                  <b>Contact: </b> {AccountData.id || 0}{" "}
                  {AccountData.register === "1" ? (
                    <span className="material-icons-outlined text-success fs-15">
                      verified
                    </span>
                  ) : (
                    ""
                  )}
                  <br />
                  <strong>
                    Reward Points: {AccountData.reward_point || 0}
                  </strong>
                  <br />
                  <b>Total Orders: </b>
                  {AccountData.total_order || ""}
                  <br />
                  <b>Last Update: </b>
                  {AccountData.last_visit || ""}
                </address>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <strong>
                  Receiver Details{" "}
                  <small>
                    <label className="px-2">Same As Order</label>
                    <input
                      type="checkbox"
                      name="sameAsOrder"
                      value={true}
                      onChange={(e) => this.props.BookingChangeHandler(e)}
                      checked={BookingData.sameAsOrder}
                    />
                  </small>
                </strong>
                <div className="col">
                  <label>Address *</label>
                  <input
                    className="form-control"
                    type="text"
                    name="Daddress"
                    onChange={(e) => this.props.BookingChangeHandler(e)}
                    defaultValue={
                      BookingData.sameAsOrder
                        ? AccountData.address
                          ? AccountData.address.address
                          : ""
                        : ""
                    }
                  />
                </div>
                <div className="col">
                  <label>Contact *</label>
                  <input
                    className="form-control"
                    type="text"
                    name="Dcontact"
                    onChange={(e) => this.props.BookingChangeHandler(e)}
                    onBlur={(e) => this.props.BookingChangeHandler(e)}
                    defaultValue={
                      BookingData.sameAsOrder
                        ? AccountData.address
                          ? AccountData.address.alt_contact
                          : AccountData.id
                        : ""
                    }
                  />
                </div>
                <div className="row form-group">
                  <div className="col">
                    <label>Landmark *</label>
                    <input
                      className="form-control"
                      type="text"
                      name="landmark"
                      defaultValue={
                        BookingData.sameAsOrder
                          ? AccountData.address
                            ? AccountData.address.landmark
                            : ""
                          : ""
                      }
                      onChange={(e) => this.props.BookingChangeHandler(e)}
                    />
                  </div>
                  <div className="col">
                    <label>Delivery Charge *</label>
                    <input
                      className="form-control"
                      type="text"
                      name="delivery"
                      defaultValue={BookingData.delivery}
                      onBlur={(e) => this.props.BookingChangeHandler(e)}
                      onChange={(e) => this.props.BookingChangeHandler(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="card"
          style={{ display: !AccountData.name ? "none" : "" }}
        >
          <BarcodeScanner fallback={this.handelBarcodeScanner} />
          <div className="card-body">
            <p className="text-danger">{this.state.formError}</p>
            <div className="row justify-content-center">
              <div className="form-group col-lg-3">
                <label>Product</label>
                {this.state.ProductList && (
                  <ProductAutoComplete
                    action={this.ProductChange}
                    name="product"
                    default={this.state.reset}
                    defaultFallback={this.ChangeProductStatus}
                    placeHolder="Product Name"
                    items={this.state.ProductList}
                  />
                )}
              </div>
              <div className="form-group row col-lg-3">
                <div className="col">
                  <label>
                    Qty *{" "}
                    <span
                      className={`badge ${this.state.remainQty > 0
                        ? "badge-success"
                        : "badge-danger"
                        } text-white`}
                    >
                      {this.state.remainQty || 0}
                    </span>
                  </label>
                  <div className="input-group">
                    <input
                      type="number"
                      onBlur={(e) => this.CalculateNetAmt(e)}
                      onFocus={(e) => this.CalculateNetAmt(e)}
                      onChange={(e) => this.CalculateNetAmt(e)}
                      value={this.state.qty}
                      step="0.01"
                      name="qty"
                      className="form-control"
                      required
                    />
                  </div>
                </div>
                <div className="col">
                  <label>Rate *</label>
                  <input
                    type={"number"}
                    value={this.state.rate}
                    disabled={true}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="form-group row col-lg-3">
                <div className="col">
                  <label>free *</label>
                  <input
                    type="number"
                    value={this.state.free}
                    step="0.01"
                    onFocus={(e) => this.CalculateNetAmt(e)}
                    onBlur={(e) => this.CalculateNetAmt(e)}
                    onChange={(e) => this.CalculateNetAmt(e)}
                    name="free"
                    className="form-control"
                    required
                  />
                </div>
                <div className="col">
                  <label>
                    Tax * <span>{this.state.tax}%</span>
                  </label>
                  <input
                    type={"number"}
                    value={this.state.taxAmt}
                    disabled={true}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="form-group row col-lg-3">
                <div className="col">
                  <label>Net.Amt</label>
                  <input
                    type={"number"}
                    value={this.state.netAmt}
                    disabled={true}
                    className="form-control"
                  />
                </div>
                <div className="col">
                  <label>Note</label>
                  <input
                    type="text"
                    value={this.state.note || ""}
                    onChange={(e) => this.setState({ note: e.target.value })}
                    name="note"
                    className="form-control"
                  />
                </div>
                <div className="col">
                  <label>Action</label>
                  <br />
                  <button
                    onClick={(e) => this.handleSubmit(e)}
                    className="btn btn-square btn-success text-center"
                  >
                    <span className="material-icons-outlined">add</span>
                  </button>
                </div>
              </div>
            </div>
            <table className="table table-separated table-sm">
              <thead>
                <tr>
                  <th classs="text-center">SN</th>
                  <th>Product</th>
                  <th>Qty</th>
                  <th>Rate</th>
                  <th>free</th>
                  <th>TAX {this.state.tax}%</th>
                  <th>Net Amount</th>
                  <th>Notes</th>
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody>
                {this.props.Particulars.length !== 0 ? (
                  this.props.Particulars.map((particular, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td className="col-3">{particular.name}</td>
                      <td className="col-2">
                        <div className="input-group">{particular.qty}</div>
                      </td>
                      <td>{particular.rate}</td>
                      <td className="col-1">{particular.free}</td>
                      <td>
                        <span>{particular.taxAmt}</span>
                      </td>
                      <td>
                        <span>{particular.netAmt}</span>
                      </td>
                      <td>{particular.note}</td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-square btn-danger"
                          onClick={() =>
                            this.props.removeBookingParticular(particular)
                          }
                        >
                          <span className="material-icons-outlined">clear</span>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <strong>Delivery Details</strong>
                <div className="row form-group">
                  <div className="col">
                    <label>Date *</label>
                    <DatePicker
                      className="form-control"
                      minDate={new Date()}
                      disabledKeyboardNavigation
                      withPortal
                      minTime={setHours(
                        setMinutes(today, today.getMinutes()),
                        today.getHours()
                      )}
                      maxTime={setHours(setMinutes(today, 45), 20)}
                      closeOnScroll={true}
                      showTimeSelect
                      dateFormat="yyyy-MM-dd h:mm aa"
                      selected={this.state.Ddate}
                      value={this.state.Ddate}
                      name="Ddate"
                      onChange={(e) => this.setState({ Ddate: e })}
                      placeholderText="Delivery Date"
                    />
                  </div>
                  <div className="col">
                    <label>Type *</label>
                    <select
                      className="form-control"
                      name="type"
                      onChange={(e) => this.props.BookingChangeHandler(e)}
                      defaultValue={BookingData.type}
                    >
                      <option>----Select Type----</option>
                      <option value="storepick">Store Pick</option>
                      <option value="delivery">Delivery</option>
                    </select>
                  </div>
                </div>
                <div className="row form-group">
                  <div className="col">
                    <label>Payment Type *</label>
                    <select
                      className="form-control"
                      name="payment"
                      onChange={(e) => this.props.BookingChangeHandler(e)}
                      defaultValue={BookingData.payment}
                    >
                      <option value="">---Payment Type---</option>
                      <option value="COD">COD</option>
                      <option value="Fonepay">Fonepay/Esewa</option>
                      <option value="Bank">Bank</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="col">
                    <label>Advance *</label>
                    <input
                      className="form-control"
                      type="text"
                      name="advance"
                      onChange={(e) => this.props.BookingChangeHandler(e)}
                      defaultValue={BookingData.advance}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <p
                      className="text-muted well well-sm no-shadow"
                      style={{ marginTop: 10 }}
                    >
                      <textarea
                        className="form-control"
                        rows={3}
                        name="remark"
                        onChange={(e) => this.props.BookingChangeHandler(e)}
                        placeholder={"Cake Name Or Remark"}
                      >
                        {this.props.BookingData.remark}
                      </textarea>
                    </p>
                  </div>
                  <div className="col">
                    <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                      <h6 className="mb-0 fw-bold ">Images</h6>
                    </div>
                    <div className="card-body">
                      <div className="file-group">
                        <input
                          type="file"
                          id="file"
                          multiple
                          accept="image/*"
                          onChange={(e) => this.imageHandleChange(e)}
                          required
                        />
                        <label htmlFor="file">
                          <span className="material-icons-outlined">
                            upload_file
                          </span>
                        </label>
                      </div>
                      <div className="row">
                        {this.state.previewImage.map((image, index) => (
                          <div className="col" key={index}>
                            <img
                              className="img-thumbnail"
                              width="150"
                              src={image}
                              alt="doc"
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <p className="lead text-center pb-3">
                  Amount Due{" "}
                  <span>
                    {" "}
                    {AccountData.length !== 0
                      ? AccountData.balance +
                      this.state.totalAmt -
                      this.state.cashReceive
                      : "0"}
                  </span>
                </p>
                <div className="table-responsive">
                  <table className="table table-condensed">
                    <tbody>
                      <tr>
                        <th>Subtotal:</th>
                        <td>{this.props.BookingData.netAmount}</td>
                      </tr>
                      <tr>
                        <th>Tax ({this.props.BookingData.tax})%</th>
                        <td>{this.props.BookingData.taxAmount}</td>
                      </tr>
                      <tr>
                        <th>Delivery:</th>
                        <td>{this.props.BookingData.delivery}</td>
                      </tr>
                      <tr>
                        <th>Advance:</th>
                        <td>{this.props.BookingData.advance}</td>
                      </tr>
                      <tr>
                        <th>Total:</th>
                        <td>{this.props.BookingData.grandTotal}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <footer>
              <button
                className="btn btn-success w-100"
                type="button"
                disabled={this.state.btnDisable}
                onClick={() => this.handleSalesSubmit()}
              >
                Submit Entries
              </button>
            </footer>
          </div>
        </div>
        <Modal
          show={this.state.showModal}
          className="modal-center"
          onHide={() => this.setState({ showModal: false })}
        >
          <Modal.Dialog>
            <Modal.Header>
              <h5 className="modal-title">New Customer</h5>
              <button
                type="button"
                className="btn"
                onClick={() => this.setState({ showModal: false })}
              >
                <span>×</span>
              </button>
            </Modal.Header>
            <NewCustomerModal />
          </Modal.Dialog>
        </Modal>
      </>
    );
  }
}
export default connect(
  (state) => ({
    BookingData: state.Booking.Booking,
    AccountData: state.Booking.Booking.customer,
    Particulars: state.Booking.Booking.particulars,
    CustomerList: state.Customer.CustomerList,
  }),
  {
    BookingChangeHandler,
    BookingAddParticular,
    removeBookingParticular,
    CustomerCustomersList,
    BookingSetToDefault,
  }
)(NewBooking);
